import { useCallback } from 'react';

export const useIsIncluded = (actions?: (string | number)[]) => {
  return useCallback((id: string | number) => actions?.includes(id), [actions]);
};
